import * as React from 'react'
import SettingsCircle from '~/components/SettingsCircle'
import BaseLayout from '~/layouts/BaseLayout'
import {NoStyleLink} from '~/routing/ReactRouterLinks'
import type {ISignedInRouteComponentProps} from '~/routing/Route/SignedIn'
import {staticURLs} from '~/routing/sitemap'
import styles from './styles.module.css'

// eslint-disable-next-line @typescript-eslint/no-restricted-types
interface IProps extends ISignedInRouteComponentProps<any> {
  children: React.ReactNode
}

export default class GameLobbyV2Layout extends React.Component<IProps> {
  render() {
    return (
      <BaseLayout>
        <div className={styles.topBar}>
          <div className={styles.left}>
            <NoStyleLink to={staticURLs.dashboard}>
              <img
                alt="Kapitalist"
                className={styles.logoAndBrand}
                src="/wordmark/wordmark-bar-darkFelt.svg"
              />
            </NoStyleLink>
          </div>
          <div className={styles.right}>
            <SettingsCircle authenticatedPlayer={this.props.authenticatedPlayer} />
          </div>
        </div>
        <div className={styles.gameLobbyFrame}>{this.props.children}</div>
      </BaseLayout>
    )
  }
}
